<script>

import moduleUtils from '../ModuleUtils';
import SgsRender from 'src/components/utils/sgs/SgsRender.vue';
import SgsRenderCollapse from 'src/components/utils/sgs/SgsRenderCollapse.vue';
import SgsRenderErrorList from 'src/components/utils/sgs/SgsRenderErrorList.vue';
import utils from '../FormBuilderUtils.js';
import {mapActions, mapGetters} from 'vuex';
import utilsService from 'src/services/UtilsService';

import SgsRenderNotificationSuccess from 'src/components/utils/sgs/SgsRenderNotificationSuccess.vue';
import SgsRenderNotificationError from 'src/components/utils/sgs/SgsRenderNotificationError.vue';

export default {
  props: [
    'rows', 'fields', 'formIdentifier',
    'id', 'parentId', 'parentColumnName',
    'title', 'businessRulesBeforeOtherView'
  ],
  components: {
    SgsRender,
    SgsRenderErrorList,
    SgsRenderCollapse,
    SgsRenderNotificationSuccess,
    SgsRenderNotificationError
  },
  data () {
    return {
      instance: {},
      errors: [],
      rules: {},
      rowsToShow: [],
      notificationError: null,
      notificationSuccess: null
    }
  },
  computed: {
    messageCreateOrUpdate: function () {
      return this.instance.id ? this.$t('updated') : this.$t('created')
    }
  },
  methods: {
    ...mapActions([
      'showLoader',
      'hideLoader'
    ]),
    getField: function(id) {
      return utils.findField(id, this.fields);
    },
    getColumnName: function(id) {

      var el = this.getField(id)
      if (el != undefined) {

        if (el.type == "errorList") {
          return el.property;
        }

        return el.columnName;
      }

      return "";
    },
    updateField: function(fieldName, fieldValue) {
      this.$set(this.instance, fieldName, fieldValue);
      // this.instance[fieldName] = fieldValue;
    },
    callBusinessRule: function(businessRuleId) {

      this.showLoader();

      moduleUtils.callBusinessRule(this.formIdentifier, this.instance, businessRuleId)
        .then(response => {

          this.hideLoader();

          _.forOwn(response.body.instance, (value, key) => {
            this.$set(this.instance, key, value);
          });

          this.notificationError = response.body.notificationError;
          this.notificationSuccess = response.body.notificationSuccess;
        });
    },
    actionLinkSelected: function(formId, dataRow) {
      this.$emit('actionLinkSelected', formId, dataRow);
    }
  },
  mounted: function() {

    this.showLoader();

    if (this.rows !== undefined && this.fields !== undefined) {

      let collapseField = null;

      this.rows.map(row => {

        let newRow = {"cols": []};
        let eARowDoCollapse = false;

        row.cols.map(col => {

          if(col.fields.length > 0) {

            let newCol = {
              "width": col.width,
              "fields": []
            }

            col.fields.map(field => {

              let fieldFound = this.getField(field.id);

              if (fieldFound.id) {

                newCol.fields.push(fieldFound);

                if (fieldFound.type == 'collapse') {
                  eARowDoCollapse = true;
                  collapseField = fieldFound;
                  collapseField.rows = [];
                }
              }
            });

            if (newCol.fields.length > 0) {
              newRow.cols.push(newCol);
            }
          }
        });

        if (newRow.cols.length > 0) {

          if (collapseField) {

            if (eARowDoCollapse) {
              this.rowsToShow.push(newRow);
            } else {
              collapseField.rows.push(newRow);
            }

          } else {
            this.rowsToShow.push(newRow);
          }

        } else {
          collapseField = null;
        }
      });
    }

    this.fields.map(it => {
      if (it.columnName && it.type !== 'dashboard') {
        this.$set(this.instance, it.columnName, "")
      }
    });

    if (this.parentId != undefined) {
      this.$set(this.instance, 'parentId', this.parentId);
    }

    if(this.businessRulesBeforeOtherView) {
      this.callBusinessRule(this.businessRulesBeforeOtherView);
    }

    this.hideLoader();
  }
}
</script>

<template>
  <div>

    <SgsRenderNotificationSuccess v-model="notificationSuccess"/>
    <SgsRenderNotificationError v-model="notificationError"/>

    <div class="page-header">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-body">

        <SgsRenderErrorList :fieldValue="instance.errors"/>

        <el-form label-position="top" :rules="rules" :model="instance" ref="instance">

          <div class="row" v-for="row in rowsToShow">

            <div v-for="col in row.cols" :class="'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width">

              <template v-for="field in col.fields">

                <SgsRender
                  v-if="field.type != 'collapse'"
                  moduleType="form"
                  :type="field.type"
                  :attr="field"
                  @input="updateField"
                  :rules="rules"
                  @actionLinkSelected="actionLinkSelected"
                  :fieldValue="instance[field.columnName]"
                  @callBusinessRule="callBusinessRule"
                  :formIdentifier="formIdentifier"
                  :instance="instance"
                />

                <SgsRenderCollapse v-else :attr="field" moduleType="form">

                  <div class="row" v-for="row in field.rows">

                    <div v-for="col in row.cols" :class="'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width">

                      <template v-for="field in col.fields">

                        <SgsRender
                          v-if="field.type != 'collapse'"
                          moduleType="form"
                          :type="field.type"
                          :attr="field"
                          @input="updateField"
                          :rules="rules"
                          @actionLinkSelected="actionLinkSelected"
                          :fieldValue="instance[field.columnName]"
                          @callBusinessRule="callBusinessRule"
                          :formIdentifier="formIdentifier"
                          :instance="instance"
                        />

                      </template>

                    </div>

                  </div>

                </SgsRenderCollapse>

              </template>

            </div>

          </div>
        </el-form>

      </div>
    </div>
  </div>
</template>

<style scoped>
  label.el-form-item__label {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// ModuleDashboard.vue?50e7f160